// /**
//  * ============================================================================
//  * FABRIC SAMPLE LIMIT — maximum 8 fabrics per order (theme-side)
//  * ============================================================================
//  * A line item counts as a fabric sample if ANY ONE of these is true (OR):
//  *   1. Product type = "fabric-sample"
//  *   2. Product is in the "Stof" collection
//  *   3. Product has the tag "fabric-sample"
//  *
//  * Behaviour:
//  *   - Up to 8 fabrics can be added.
//  *   - Once 8 are in the cart, "Maximum 8 fabrics allowed" is shown.
//  *   - A 9th fabric is NOT added — the add request is cancelled before it is
//  *     sent, so nothing ever lands in the cart.
//  *   - Instead, a panel lists the fabrics already in the cart with a Remove
//  *     button on each. Removing one frees a slot and the blocked fabric is
//  *     added automatically.
//  *
//  * All three conditions are evaluated server-side in Liquid
//  * (snippets/fabric-sample-data.liquid + sections/fabric-sample-ids.liquid),
//  * so tags and collections stay accurate without hardcoding IDs here.
//  *
//  * LIMITATION: this is a front-end guard. It cannot stop a shopper with
//  * JavaScript disabled or one posting straight to /cart/add.js. Real
//  * enforcement requires the Cart & Checkout Validation Function in
//  * shopify-app/ (see shopify-app/SETUP.md).
//  * ============================================================================
//  */
// (() => {
//   if (window.fabricSampleLimitInitialized) return;
//   window.fabricSampleLimitInitialized = true;

//   const COUNT_SECTION = 'fabric-sample-count';
//   const IDS_SECTION = 'fabric-sample-ids';
//   const COLLECTION_HANDLE = 'stof';
//   const TAG_HANDLE = 'fabric-sample';
//   const STORAGE_KEY = 'fabricSampleVariantIds';
//   const NOTICE_CLASS = 'fabric-sample-limit-notice';
//   const PANEL_CLASS = 'fabric-sample-limit-panel';

//   const DEFAULTS = {
//     max: 8,
//     total: 0,
//     message: 'Maximum 8 fabrics allowed',
//     blockedMessage: 'Maximum 8 fabrics allowed. Remove one of the fabrics below to add a new one.',
//     removeLabel: 'Remove',
//     currentProductIsSample: false,
//     currentProductVariantIds: [],
//     lines: [],
//   };

//   let state = { ...DEFAULTS };
//   let busy = false;

//   /** Variant IDs we know are fabric samples (strings). */
//   const sampleVariants = new Set();
//   let idsLoaded = false;
//   let idsPromise = null;

//   /**
//    * The browser's own fetch, captured before we wrap it below. Every internal
//    * request uses this so our own calls (including the automatic re-add after a
//    * removal) are never intercepted by our own guard.
//    */
//   const nativeFetch = window.fetch.bind(window);

//   const rootUrl = () =>
//     (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

//   /* ------------------------------------------------------------------ data */

//   function readData(doc = document) {
//     const nodes = doc.querySelectorAll('[data-fabric-sample-data]');
//     if (!nodes.length) return null;

//     try {
//       return JSON.parse(nodes[nodes.length - 1].textContent);
//     } catch (error) {
//       console.warn('[fabric-sample-limit] could not parse data', error);
//       return null;
//     }
//   }

//   function setState(data) {
//     if (!data) return;
//     state = { ...DEFAULTS, ...data };

//     // Learn variant IDs from whatever the server just told us.
//     if (state.currentProductIsSample) {
//       (state.currentProductVariantIds || []).forEach((id) => sampleVariants.add(String(id)));
//     }
//     (state.lines || []).forEach((line) => {
//       if (line.sample) sampleVariants.add(String(line.variantId));
//     });
//   }

//   /**
//    * Instant local recount from the cart JSON the theme hands us on every
//    * change. No network round trip, so the message updates the moment a
//    * quantity changes — and it still works if the helper sections were never
//    * uploaded to the theme.
//    *
//    * Sample detection here uses the product type plus every variant ID we have
//    * already learned to be a fabric; the server refresh below reconciles the
//    * collection- and tag-only cases.
//    */
//   function applyCart(cart) {
//     if (!cart || !Array.isArray(cart.items)) return;

//     const previous = new Map(
//       (state.lines || []).map((line) => [String(line.variantId), line.sample])
//     );

//     let total = 0;
//     const lines = cart.items.map((item) => {
//       const variantId = String(item.variant_id);
//       const productType = String(item.product_type || '').trim().toLowerCase();

//       const sample =
//         productType === 'fabric-sample' ||
//         isSampleVariant(variantId) ||
//         previous.get(variantId) === true;

//       if (sample) {
//         total += item.quantity;
//         sampleVariants.add(variantId);
//       }

//       return {
//         key: item.key,
//         productId: item.product_id,
//         variantId: item.variant_id,
//         quantity: item.quantity,
//         title: item.product_title || item.title,
//         image: item.image || '',
//         sample,
//       };
//     });

//     state = { ...state, total, lines };
//   }

//   /** Authoritative recount from the server (all 3 conditions in Liquid). */
//   async function refresh() {
//     // Preferred: the tiny dedicated section.
//     // Fallback: the cart page, which renders the same snippet — this keeps
//     // working even if sections/fabric-sample-count.liquid wasn't uploaded.
//     const urls = [`${rootUrl()}?section_id=${COUNT_SECTION}`, `${rootUrl()}cart`];

//     for (const url of urls) {
//       try {
//         // eslint-disable-next-line no-await-in-loop
//         const response = await nativeFetch(url, { headers: { Accept: 'text/html' } });
//         if (!response.ok) continue;

//         // eslint-disable-next-line no-await-in-loop
//         const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
//         const data = readData(doc);
//         if (!data) continue;

//         setState(data);
//         return;
//       } catch (error) {
//         /* try the next source */
//       }
//     }

//     console.warn('[fabric-sample-limit] could not refresh the count from the server');
//   }

//   /* ------------------------------------------------- sample variant ID list */

//   async function fetchIdsFrom(path) {
//     const ids = [];

//     for (let page = 1; page <= 5; page++) {
//       const url = `${rootUrl()}${path}?section_id=${IDS_SECTION}${page > 1 ? `&page=${page}` : ''}`;

//       // eslint-disable-next-line no-await-in-loop
//       const response = await nativeFetch(url, { headers: { Accept: 'text/html' } });
//       if (!response.ok) break;

//       // eslint-disable-next-line no-await-in-loop
//       const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
//       const node = doc.querySelector('[data-fabric-sample-ids]');
//       if (!node) break;

//       let payload;
//       try {
//         payload = JSON.parse(node.textContent);
//       } catch (error) {
//         break;
//       }

//       (payload.ids || []).forEach((id) => ids.push(String(id)));
//       if (!payload.hasNextPage) break;
//     }

//     return ids;
//   }

//   /** Load (and cache) every fabric sample variant ID we can enumerate. */
//   function ensureIds() {
//     if (idsLoaded) return Promise.resolve();
//     if (idsPromise) return idsPromise;

//     const cached = (() => {
//       try {
//         return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
//       } catch (error) {
//         return null;
//       }
//     })();

//     if (Array.isArray(cached) && cached.length) {
//       cached.forEach((id) => sampleVariants.add(String(id)));
//       idsLoaded = true;
//       return Promise.resolve();
//     }

//     idsPromise = Promise.all([
//       fetchIdsFrom(`collections/${COLLECTION_HANDLE}`).catch(() => []),
//       fetchIdsFrom(`collections/all/${TAG_HANDLE}`).catch(() => []),
//     ])
//       .then(([fromCollection, fromTag]) => {
//         [...fromCollection, ...fromTag].forEach((id) => sampleVariants.add(id));
//         idsLoaded = true;
//         try {
//           sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...sampleVariants]));
//         } catch (error) {
//           /* storage full or blocked — not fatal */
//         }
//       })
//       .finally(() => {
//         idsPromise = null;
//       });

//     return idsPromise;
//   }

//   const isSampleVariant = (id) => sampleVariants.has(String(id));

//   /* --------------------------------------------------------------- cart ops */

//   async function changeLine(key, quantity) {
//     await nativeFetch(`${rootUrl()}cart/change.js`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//       body: JSON.stringify({ id: key, quantity }),
//     });
//   }

//   async function notifyCartChanged() {
//     try {
//       const cart = await (await nativeFetch(`${rootUrl()}cart.js`)).json();
//       document.documentElement.dispatchEvent(
//         new CustomEvent('cart:change', { bubbles: true, detail: { cart } })
//       );
//     } catch (error) {
//       /* non-fatal */
//     }
//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//   }

//   /** Safety net: if anything slipped through, trim back down to the limit. */
//   async function trimToLimit() {
//     let overflow = state.total - state.max;
//     const sampleLines = (state.lines || []).filter((line) => line.sample);

//     for (let i = sampleLines.length - 1; i >= 0 && overflow > 0; i--) {
//       const line = sampleLines[i];
//       const reduceBy = Math.min(line.quantity, overflow);
//       // eslint-disable-next-line no-await-in-loop
//       await changeLine(line.key, line.quantity - reduceBy);
//       overflow -= reduceBy;
//     }

//     await refresh();
//     await notifyCartChanged();
//   }

//   /* --------------------------------------------------------------------- UI */

//   function injectStyles() {
//     if (document.getElementById('fabric-sample-limit-styles')) return;

//     const style = document.createElement('style');
//     style.id = 'fabric-sample-limit-styles';
//     style.textContent = `
//       .${NOTICE_CLASS} {
//         margin: 0 0 0.75rem;
//         padding: 0.7rem 0.9rem;
//         border: 1px solid currentColor;
//         border-radius: var(--rounded-sm, 4px);
//         font-size: 0.875rem;
//         line-height: 1.4;
//         opacity: 0.95;
//       }
//       .${NOTICE_CLASS}--info { border-style: dashed; }
//       .${PANEL_CLASS} {
//         margin: 0.75rem 0 0;
//         padding: 0.9rem;
//         border: 1px solid rgb(var(--text-color) / 0.2);
//         border-radius: var(--rounded-sm, 4px);
//         background: rgb(var(--background) / 1);
//         font-size: 0.875rem;
//       }
//       .${PANEL_CLASS}__title { margin: 0 0 0.6rem; font-weight: 500; }
//       .${PANEL_CLASS}__list { list-style: none; margin: 0; padding: 0; }
//       .${PANEL_CLASS}__item {
//         display: flex;
//         align-items: center;
//         gap: 0.6rem;
//         padding: 0.4rem 0;
//         border-top: 1px solid rgb(var(--text-color) / 0.12);
//       }
//       .${PANEL_CLASS}__item:first-child { border-top: 0; }
//       .${PANEL_CLASS}__thumb {
//         width: 34px; height: 34px; object-fit: cover; flex: none;
//         border-radius: 2px; background: rgb(var(--text-color) / 0.06);
//       }
//       .${PANEL_CLASS}__name { flex: 1 1 auto; }
//       .${PANEL_CLASS}__remove {
//         flex: none; cursor: pointer; background: none; border: 0; padding: 0.2rem 0.1rem;
//         text-decoration: underline; color: inherit; font-size: 0.8125rem;
//       }
//       .${PANEL_CLASS}__remove[disabled] { opacity: 0.5; cursor: wait; }
//     `;
//     document.head.appendChild(style);
//   }

//   function noticeElement(text, variant = 'info') {
//     const notice = document.createElement('div');
//     notice.className = `${NOTICE_CLASS} ${NOTICE_CLASS}--${variant}`;
//     notice.setAttribute('role', 'status');
//     notice.textContent = text;
//     return notice;
//   }

//   /** "Maximum 8 fabrics allowed" above the checkout button once at the limit. */
//   function renderUI() {
//     const atLimit = state.total >= state.max;

//     document.querySelectorAll('button[name="checkout"]').forEach((button) => {
//       const container = button.parentElement;
//       if (!container) return;

//       const existing = container.querySelector(`.${NOTICE_CLASS}`);

//       if (atLimit) {
//         if (!existing) container.insertBefore(noticeElement(state.message), button);
//       } else {
//         existing?.remove();
//       }
//     });
//   }

//   /**
//    * The 9th fabric was blocked. Show the message plus every fabric already in
//    * the cart, each with a Remove button. Removing one frees a slot and the
//    * blocked fabric is added automatically.
//    */
//   function showBlockedPanel(anchorForm, pendingItem) {
//     const container =
//       anchorForm?.querySelector('[type="submit"], button[name="add"]')?.closest('.v-stack') ||
//       anchorForm ||
//       document.querySelector('[data-fabric-sample-data]')?.parentElement;

//     if (!container) return;

//     container.querySelector(`.${PANEL_CLASS}`)?.remove();

//     const panel = document.createElement('div');
//     panel.className = PANEL_CLASS;

//     const title = document.createElement('p');
//     title.className = `${PANEL_CLASS}__title`;
//     title.textContent = state.blockedMessage;
//     panel.appendChild(title);

//     const list = document.createElement('ul');
//     list.className = `${PANEL_CLASS}__list`;

//     (state.lines || [])
//       .filter((line) => line.sample)
//       .forEach((line) => {
//         const item = document.createElement('li');
//         item.className = `${PANEL_CLASS}__item`;

//         if (line.image) {
//           const img = document.createElement('img');
//           img.className = `${PANEL_CLASS}__thumb`;
//           img.src = line.image;
//           img.alt = '';
//           img.loading = 'lazy';
//           item.appendChild(img);
//         }

//         const name = document.createElement('span');
//         name.className = `${PANEL_CLASS}__name`;
//         name.textContent =
//           line.quantity > 1 ? `${line.title} × ${line.quantity}` : line.title;
//         item.appendChild(name);

//         const remove = document.createElement('button');
//         remove.type = 'button';
//         remove.className = `${PANEL_CLASS}__remove`;
//         remove.textContent = state.removeLabel;
//         remove.addEventListener('click', async () => {
//           remove.disabled = true;
//           await swapLine(line, pendingItem);
//           panel.remove();
//         });
//         item.appendChild(remove);

//         list.appendChild(item);
//       });

//     panel.appendChild(list);
//     container.appendChild(panel);

//     if (typeof panel.scrollIntoView === 'function') {
//       panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
//     }
//   }

//   /** Remove one unit of `line`, then add the fabric that was blocked. */
//   async function swapLine(line, pendingItem) {
//     busy = true;

//     try {
//       await changeLine(line.key, Math.max(0, line.quantity - 1));

//       if (pendingItem) {
//         await nativeFetch(`${rootUrl()}cart/add.js`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//           body: JSON.stringify({ id: pendingItem.id, quantity: pendingItem.quantity }),
//         });
//       }

//       await refresh();
//       renderUI();
//       await notifyCartChanged();
//     } finally {
//       busy = false;
//     }
//   }

//   /* ------------------------------------------------ add-to-cart interception */

//   /** Pull {id, quantity} pairs out of any /cart/add body shape. */
//   function parseAddItems(body) {
//     const items = [];

//     const push = (id, quantity) => {
//       if (id == null) return;
//       items.push({ id: String(id), quantity: Math.max(1, parseInt(quantity, 10) || 1) });
//     };

//     if (body instanceof FormData || body instanceof URLSearchParams) {
//       push(body.get('id'), body.get('quantity'));
//       return items;
//     }

//     if (typeof body === 'string') {
//       try {
//         const json = JSON.parse(body);
//         if (Array.isArray(json.items)) {
//           json.items.forEach((item) => push(item.id, item.quantity));
//         } else {
//           push(json.id, json.quantity);
//         }
//       } catch (error) {
//         const params = new URLSearchParams(body);
//         push(params.get('id'), params.get('quantity'));
//       }
//     }

//     return items;
//   }

//   /**
//    * @returns {Promise<null|{item: object}>} the blocked item, or null if the
//    * add is allowed through.
//    */
//   async function checkAdd(body) {
//     const items = parseAddItems(body);
//     if (!items.length) return null;

//     // Fast path: nothing can exceed the limit, don't even look up IDs.
//     const requested = items.reduce((sum, item) => sum + item.quantity, 0);
//     if (state.total + requested <= state.max) return null;

//     await ensureIds();

//     const sampleQuantity = items
//       .filter((item) => isSampleVariant(item.id))
//       .reduce((sum, item) => sum + item.quantity, 0);

//     if (sampleQuantity === 0) return null;
//     if (state.total + sampleQuantity <= state.max) return null;

//     return { item: items.find((item) => isSampleVariant(item.id)) };
//   }

//   function blockedResponse() {
//     return new Response(
//       JSON.stringify({
//         status: 422,
//         message: state.message,
//         description: state.message,
//       }),
//       { status: 422, headers: { 'Content-Type': 'application/json' } }
//     );
//   }

//   /**
//    * A quantity increase on the cart page / drawer goes through /cart/change.js.
//    * Block it when it would push the fabric total past the limit.
//    *
//    * @returns {boolean} true when the change must be refused.
//    */
//   function checkChange(body) {
//     let payload = body;

//     if (body instanceof FormData || body instanceof URLSearchParams) {
//       payload = { id: body.get('id'), quantity: body.get('quantity'), line: body.get('line') };
//     } else if (typeof body === 'string') {
//       try {
//         payload = JSON.parse(body);
//       } catch (error) {
//         const params = new URLSearchParams(body);
//         payload = { id: params.get('id'), quantity: params.get('quantity'), line: params.get('line') };
//       }
//     }

//     if (!payload || payload.quantity == null) return false;

//     const quantity = parseInt(payload.quantity, 10);
//     if (Number.isNaN(quantity)) return false;

//     const lines = state.lines || [];
//     const line =
//       payload.line != null
//         ? lines[parseInt(payload.line, 10) - 1]
//         : lines.find((candidate) => String(candidate.key) === String(payload.id));

//     if (!line || !line.sample) return false;

//     const delta = quantity - line.quantity;
//     if (delta <= 0) return false;

//     return state.total + delta > state.max;
//   }

//   /** Intercept add-to-cart and quantity-increase requests, wherever they come from. */
//   function interceptFetch() {
//     const originalFetch = nativeFetch;

//     window.fetch = async function fabricSampleFetch(input, init = {}) {
//       const url = typeof input === 'string' ? input : input?.url || '';
//       const isAdd = url.includes('/cart/add');
//       const isChange = url.includes('/cart/change');

//       if (!isAdd && !isChange) return originalFetch(input, init);

//       let body = init?.body;
//       if (!body && input instanceof Request) {
//         try {
//           body = await input.clone().text();
//         } catch (error) {
//           body = undefined;
//         }
//       }

//       if (isChange) {
//         let refuse = false;
//         try {
//           refuse = checkChange(body);
//         } catch (error) {
//           console.warn('[fabric-sample-limit] change pre-check failed, allowing', error);
//         }

//         if (refuse) {
//           try {
//             renderUI();
//           } catch (error) {
//             /* non-fatal */
//           }
//           return blockedResponse();
//         }

//         return originalFetch(input, init);
//       }

//       let blocked = null;
//       try {
//         blocked = await checkAdd(body);
//       } catch (error) {
//         console.warn('[fabric-sample-limit] pre-check failed, allowing add', error);
//       }

//       if (blocked) {
//         // The block must hold even if rendering the panel fails.
//         try {
//           const form = document.activeElement?.closest?.('form');
//           showBlockedPanel(form, blocked.item);
//           renderUI();
//         } catch (error) {
//           console.warn('[fabric-sample-limit] could not render the panel', error);
//         }
//         return blockedResponse();
//       }

//       return originalFetch(input, init);
//     };
//   }

//   /** Extra early block on a fabric sample product page — no request at all. */
//   function onSubmitCapture(event) {
//     const form = event.target;
//     if (!(form instanceof HTMLFormElement)) return;
//     if (!form.action || !form.action.includes('/cart/add')) return;
//     if (!state.currentProductIsSample) return;

//     const quantity = Math.max(
//       1,
//       parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1
//     );
//     if (state.total + quantity <= state.max) return;

//     const id = form.querySelector('[name="id"]:not([disabled])')?.value;

//     event.preventDefault();
//     event.stopImmediatePropagation();
//     showBlockedPanel(form, id ? { id: String(id), quantity } : null);
//     renderUI();
//   }

//   /* ---------------------------------------------------------------- wiring */

//   /**
//    * The theme re-renders the cart page / drawer after a quantity change, which
//    * replaces our notice along with the rest of the markup. Watch for the
//    * freshly server-rendered payload and re-apply the message immediately, so
//    * the count is right without a page reload.
//    */
//   function observeCartRenders() {
//     let scheduled = false;

//     const observer = new MutationObserver((mutations) => {
//       let dataNode = null;
//       let sawCheckout = false;

//       mutations.forEach((mutation) => {
//         mutation.addedNodes.forEach((node) => {
//           if (!(node instanceof Element)) return;
//           // Ignore the elements we inject ourselves, or this loops forever.
//           if (node.classList.contains(NOTICE_CLASS) || node.classList.contains(PANEL_CLASS)) return;

//           if (node.matches('[data-fabric-sample-data]')) {
//             dataNode = node;
//           } else {
//             const found = node.querySelector?.('[data-fabric-sample-data]');
//             if (found) dataNode = found;
//           }

//           if (
//             node.matches('button[name="checkout"]') ||
//             node.querySelector?.('button[name="checkout"]')
//           ) {
//             sawCheckout = true;
//           }
//         });
//       });

//       if (!dataNode && !sawCheckout) return;
//       if (scheduled) return;
//       scheduled = true;

//       requestAnimationFrame(() => {
//         scheduled = false;

//         if (dataNode) {
//           try {
//             setState(JSON.parse(dataNode.textContent));
//           } catch (error) {
//             /* keep the previous state */
//           }
//         }

//         renderUI();
//       });
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   async function onCartChange(event) {
//     // 1. Update the message immediately from the cart JSON the theme provides.
//     const cart = event?.detail?.cart;
//     if (cart) {
//       applyCart(cart);
//       renderUI();
//     }

//     // 2. Then reconcile against the server, which knows about collections and tags.
//     if (busy) return;
//     busy = true;

//     try {
//       await refresh();
//       if (state.total > state.max) await trimToLimit();
//       renderUI();
//     } finally {
//       busy = false;
//     }
//   }

//   function initialize() {
//     injectStyles();
//     setState(readData());
//     renderUI();
//     interceptFetch();

//     observeCartRenders();

//     document.addEventListener('submit', onSubmitCapture, true);
//     document.addEventListener('cart:change', onCartChange);
//     document.addEventListener('cart-drawer:refreshed', (event) => {
//       setState(readData(event.target) || readData());
//       renderUI();
//     });

//     // Warm the ID cache when the browser is idle, so the first block is instant.
//     const warm = () => ensureIds().catch(() => {});
//     if ('requestIdleCallback' in window) {
//       requestIdleCallback(warm, { timeout: 4000 });
//     } else {
//       setTimeout(warm, 2000);
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initialize, { once: true });
//   } else {
//     initialize();
//   }

//   // Small public API, handy for debugging in the console.
//   window.FabricSampleLimit = {
//     get state() {
//       return state;
//     },
//     get sampleVariants() {
//       return [...sampleVariants];
//     },
//     refresh,
//     renderUI,
//   };
// })();

/**
 * ============================================================================
 * FABRIC SAMPLE LIMIT — maximum 8 fabrics per order (theme-side)
 * ============================================================================
 * A line item counts as a fabric sample if ANY ONE of these is true (OR):
 *   1. Product type = "fabric-sample"
 *   2. Product is in the "Stof" collection
 *   3. Product has the tag "fabric-sample"
 *
 * Behaviour:
 *   - Up to 8 fabrics can be added.
 *   - Once 8 are in the cart, "Maximum 8 fabrics allowed" is shown.
 *   - A 9th fabric is NOT added — the add request is cancelled before it is
 *     sent, so nothing ever lands in the cart. Only the error message is shown;
 *     the customer removes a fabric from the cart themselves to make room.
 *
 * All three conditions are evaluated server-side in Liquid
 * (snippets/fabric-sample-data.liquid + sections/fabric-sample-ids.liquid),
 * so tags and collections stay accurate without hardcoding IDs here.
 *
 * LIMITATION: this is a front-end guard. It cannot stop a shopper with
 * JavaScript disabled or one posting straight to /cart/add.js. Real
 * enforcement requires the Cart & Checkout Validation Function in
 * shopify-app/ (see shopify-app/SETUP.md).
 * ============================================================================
 */
(() => {
  if (window.fabricSampleLimitInitialized) return;
  window.fabricSampleLimitInitialized = true;

  const COUNT_SECTION = 'fabric-sample-count';
  const IDS_SECTION = 'fabric-sample-ids';
  const COLLECTION_HANDLE = 'stof';
  const TAG_HANDLE = 'fabric-sample';
  const STORAGE_KEY = 'fabricSampleVariantIds';
  const NOTICE_CLASS = 'fabric-sample-limit-notice';

  const DEFAULTS = {
    max: 8,
    total: 0,
    message: 'Maximum 8 fabrics allowed',
    currentProductIsSample: false,
    currentProductVariantIds: [],
    lines: [],
  };

  let state = { ...DEFAULTS };
  let busy = false;

  /** Variant IDs we know are fabric samples (strings). */
  const sampleVariants = new Set();
  let idsLoaded = false;
  let idsPromise = null;

  /**
   * The browser's own fetch, captured before we wrap it below. Every internal
   * request uses this so our own calls (including the automatic re-add after a
   * removal) are never intercepted by our own guard.
   */
  const nativeFetch = window.fetch.bind(window);

  const rootUrl = () =>
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------------------------------------------ data */

  function readData(doc = document) {
    const nodes = doc.querySelectorAll('[data-fabric-sample-data]');
    if (!nodes.length) return null;

    try {
      return JSON.parse(nodes[nodes.length - 1].textContent);
    } catch (error) {
      console.warn('[fabric-sample-limit] could not parse data', error);
      return null;
    }
  }

  function setState(data) {
    if (!data) return;
    state = { ...DEFAULTS, ...data };

    // Learn variant IDs from whatever the server just told us.
    if (state.currentProductIsSample) {
      (state.currentProductVariantIds || []).forEach((id) => sampleVariants.add(String(id)));
    }
    (state.lines || []).forEach((line) => {
      if (line.sample) sampleVariants.add(String(line.variantId));
    });
  }

  /**
   * Instant local recount from the cart JSON the theme hands us on every
   * change. No network round trip, so the message updates the moment a
   * quantity changes — and it still works if the helper sections were never
   * uploaded to the theme.
   *
   * Sample detection here uses the product type plus every variant ID we have
   * already learned to be a fabric; the server refresh below reconciles the
   * collection- and tag-only cases.
   */
  function applyCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    const previous = new Map(
      (state.lines || []).map((line) => [String(line.variantId), line.sample])
    );

    let total = 0;
    const lines = cart.items.map((item) => {
      const variantId = String(item.variant_id);
      const productType = String(item.product_type || '').trim().toLowerCase();

      const sample =
        productType === 'fabric-sample' ||
        isSampleVariant(variantId) ||
        previous.get(variantId) === true;

      if (sample) {
        total += item.quantity;
        sampleVariants.add(variantId);
      }

      return {
        key: item.key,
        productId: item.product_id,
        variantId: item.variant_id,
        quantity: item.quantity,
        title: item.product_title || item.title,
        image: item.image || '',
        sample,
      };
    });

    state = { ...state, total, lines };
  }

  /** Authoritative recount from the server (all 3 conditions in Liquid). */
  async function refresh() {
    // Preferred: the tiny dedicated section.
    // Fallback: the cart page, which renders the same snippet — this keeps
    // working even if sections/fabric-sample-count.liquid wasn't uploaded.
    const urls = [`${rootUrl()}?section_id=${COUNT_SECTION}`, `${rootUrl()}cart`];

    for (const url of urls) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const response = await nativeFetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) continue;

        // eslint-disable-next-line no-await-in-loop
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = readData(doc);
        if (!data) continue;

        setState(data);
        return;
      } catch (error) {
        /* try the next source */
      }
    }

    console.warn('[fabric-sample-limit] could not refresh the count from the server');
  }

  /* ------------------------------------------------- sample variant ID list */

  async function fetchIdsFrom(path) {
    const ids = [];

    for (let page = 1; page <= 5; page++) {
      const url = `${rootUrl()}${path}?section_id=${IDS_SECTION}${page > 1 ? `&page=${page}` : ''}`;

      // eslint-disable-next-line no-await-in-loop
      const response = await nativeFetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) break;

      // eslint-disable-next-line no-await-in-loop
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = doc.querySelector('[data-fabric-sample-ids]');
      if (!node) break;

      let payload;
      try {
        payload = JSON.parse(node.textContent);
      } catch (error) {
        break;
      }

      (payload.ids || []).forEach((id) => ids.push(String(id)));
      if (!payload.hasNextPage) break;
    }

    return ids;
  }

  /** Load (and cache) every fabric sample variant ID we can enumerate. */
  function ensureIds() {
    if (idsLoaded) return Promise.resolve();
    if (idsPromise) return idsPromise;

    const cached = (() => {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (error) {
        return null;
      }
    })();

    if (Array.isArray(cached) && cached.length) {
      cached.forEach((id) => sampleVariants.add(String(id)));
      idsLoaded = true;
      return Promise.resolve();
    }

    idsPromise = Promise.all([
      fetchIdsFrom(`collections/${COLLECTION_HANDLE}`).catch(() => []),
      fetchIdsFrom(`collections/all/${TAG_HANDLE}`).catch(() => []),
    ])
      .then(([fromCollection, fromTag]) => {
        [...fromCollection, ...fromTag].forEach((id) => sampleVariants.add(id));
        idsLoaded = true;
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...sampleVariants]));
        } catch (error) {
          /* storage full or blocked — not fatal */
        }
      })
      .finally(() => {
        idsPromise = null;
      });

    return idsPromise;
  }

  const isSampleVariant = (id) => sampleVariants.has(String(id));

  /* --------------------------------------------------------------- cart ops */

  async function changeLine(key, quantity) {
    await nativeFetch(`${rootUrl()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
  }

  async function notifyCartChanged() {
    try {
      const cart = await (await nativeFetch(`${rootUrl()}cart.js`)).json();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { cart } })
      );
    } catch (error) {
      /* non-fatal */
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /** Safety net: if anything slipped through, trim back down to the limit. */
  async function trimToLimit() {
    let overflow = state.total - state.max;
    const sampleLines = (state.lines || []).filter((line) => line.sample);

    for (let i = sampleLines.length - 1; i >= 0 && overflow > 0; i--) {
      const line = sampleLines[i];
      const reduceBy = Math.min(line.quantity, overflow);
      // eslint-disable-next-line no-await-in-loop
      await changeLine(line.key, line.quantity - reduceBy);
      overflow -= reduceBy;
    }

    await refresh();
    await notifyCartChanged();
  }

  /* --------------------------------------------------------------------- UI */

  function injectStyles() {
    if (document.getElementById('fabric-sample-limit-styles')) return;

    const style = document.createElement('style');
    style.id = 'fabric-sample-limit-styles';
    style.textContent = `
      .${NOTICE_CLASS} {
        margin: 0 0 0.75rem;
        padding: 0.7rem 0.9rem;
        border: 1px solid currentColor;
        border-radius: var(--rounded-sm, 4px);
        font-size: 0.875rem;
        line-height: 1.4;
        opacity: 0.95;
      }
      .${NOTICE_CLASS}--info { border-style: dashed; }
      .${NOTICE_CLASS}--error { border-style: solid; font-weight: 500; }
    `;
    document.head.appendChild(style);
  }

  function noticeElement(text, variant = 'info') {
    const notice = document.createElement('div');
    notice.className = `${NOTICE_CLASS} ${NOTICE_CLASS}--${variant}`;
    notice.setAttribute('role', 'status');
    notice.textContent = text;
    return notice;
  }

  /** "Maximum 8 fabrics allowed" above the checkout button once at the limit. */
  function renderUI() {
    const atLimit = state.total >= state.max;

    document.querySelectorAll('button[name="checkout"]').forEach((button) => {
      const container = button.parentElement;
      if (!container) return;

      const existing = container.querySelector(`.${NOTICE_CLASS}`);

      if (atLimit) {
        if (!existing) container.insertBefore(noticeElement(state.message), button);
      } else {
        existing?.remove();
      }
    });
  }

  /**
   * The 9th fabric was blocked. Show the error message next to the button the
   * customer just pressed — nothing is added to the cart.
   */
  function showBlockedMessage(anchorForm) {
    const container =
      anchorForm?.querySelector('[type="submit"], button[name="add"]')?.closest('.v-stack') ||
      anchorForm ||
      document.querySelector('[data-fabric-sample-data]')?.parentElement;

    if (!container) return;

    let notice = container.querySelector(`.${NOTICE_CLASS}`);
    if (!notice) {
      notice = noticeElement(state.message, 'error');
      container.appendChild(notice);
    }
    notice.textContent = state.message;

    if (typeof notice.scrollIntoView === 'function') {
      notice.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ------------------------------------------------ add-to-cart interception */

  /** Pull {id, quantity} pairs out of any /cart/add body shape. */
  function parseAddItems(body) {
    const items = [];

    const push = (id, quantity) => {
      if (id == null) return;
      items.push({ id: String(id), quantity: Math.max(1, parseInt(quantity, 10) || 1) });
    };

    if (body instanceof FormData || body instanceof URLSearchParams) {
      push(body.get('id'), body.get('quantity'));
      return items;
    }

    if (typeof body === 'string') {
      try {
        const json = JSON.parse(body);
        if (Array.isArray(json.items)) {
          json.items.forEach((item) => push(item.id, item.quantity));
        } else {
          push(json.id, json.quantity);
        }
      } catch (error) {
        const params = new URLSearchParams(body);
        push(params.get('id'), params.get('quantity'));
      }
    }

    return items;
  }

  /**
   * @returns {Promise<null|{item: object}>} the blocked item, or null if the
   * add is allowed through.
   */
  async function checkAdd(body) {
    const items = parseAddItems(body);
    if (!items.length) return null;

    // Fast path: nothing can exceed the limit, don't even look up IDs.
    const requested = items.reduce((sum, item) => sum + item.quantity, 0);
    if (state.total + requested <= state.max) return null;

    await ensureIds();

    const sampleQuantity = items
      .filter((item) => isSampleVariant(item.id))
      .reduce((sum, item) => sum + item.quantity, 0);

    if (sampleQuantity === 0) return null;
    if (state.total + sampleQuantity <= state.max) return null;

    return { item: items.find((item) => isSampleVariant(item.id)) };
  }

  function blockedResponse() {
    return new Response(
      JSON.stringify({
        status: 422,
        message: state.message,
        description: state.message,
      }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  /**
   * A quantity increase on the cart page / drawer goes through /cart/change.js.
   * Block it when it would push the fabric total past the limit.
   *
   * @returns {boolean} true when the change must be refused.
   */
  function checkChange(body) {
    let payload = body;

    if (body instanceof FormData || body instanceof URLSearchParams) {
      payload = { id: body.get('id'), quantity: body.get('quantity'), line: body.get('line') };
    } else if (typeof body === 'string') {
      try {
        payload = JSON.parse(body);
      } catch (error) {
        const params = new URLSearchParams(body);
        payload = { id: params.get('id'), quantity: params.get('quantity'), line: params.get('line') };
      }
    }

    if (!payload || payload.quantity == null) return false;

    const quantity = parseInt(payload.quantity, 10);
    if (Number.isNaN(quantity)) return false;

    const lines = state.lines || [];
    const line =
      payload.line != null
        ? lines[parseInt(payload.line, 10) - 1]
        : lines.find((candidate) => String(candidate.key) === String(payload.id));

    if (!line || !line.sample) return false;

    const delta = quantity - line.quantity;
    if (delta <= 0) return false;

    return state.total + delta > state.max;
  }

  /** Intercept add-to-cart and quantity-increase requests, wherever they come from. */
  function interceptFetch() {
    const originalFetch = nativeFetch;

    window.fetch = async function fabricSampleFetch(input, init = {}) {
      const url = typeof input === 'string' ? input : input?.url || '';
      const isAdd = url.includes('/cart/add');
      const isChange = url.includes('/cart/change');

      if (!isAdd && !isChange) return originalFetch(input, init);

      let body = init?.body;
      if (!body && input instanceof Request) {
        try {
          body = await input.clone().text();
        } catch (error) {
          body = undefined;
        }
      }

      if (isChange) {
        let refuse = false;
        try {
          refuse = checkChange(body);
        } catch (error) {
          console.warn('[fabric-sample-limit] change pre-check failed, allowing', error);
        }

        if (refuse) {
          try {
            renderUI();
          } catch (error) {
            /* non-fatal */
          }
          return blockedResponse();
        }

        return originalFetch(input, init);
      }

      let blocked = null;
      try {
        blocked = await checkAdd(body);
      } catch (error) {
        console.warn('[fabric-sample-limit] pre-check failed, allowing add', error);
      }

      if (blocked) {
        // The block must hold even if rendering the panel fails.
        try {
          const form = document.activeElement?.closest?.('form');
          showBlockedMessage(form);
          renderUI();
        } catch (error) {
          console.warn('[fabric-sample-limit] could not render the panel', error);
        }
        return blockedResponse();
      }

      return originalFetch(input, init);
    };
  }

  /** Extra early block on a fabric sample product page — no request at all. */
  function onSubmitCapture(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes('/cart/add')) return;
    if (!state.currentProductIsSample) return;

    const quantity = Math.max(
      1,
      parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1
    );
    if (state.total + quantity <= state.max) return;

    const id = form.querySelector('[name="id"]:not([disabled])')?.value;

    event.preventDefault();
    event.stopImmediatePropagation();
    showBlockedMessage(form);
    renderUI();
  }

  /* ---------------------------------------------------------------- wiring */

  /**
   * The theme re-renders the cart page / drawer after a quantity change, which
   * replaces our notice along with the rest of the markup. Watch for the
   * freshly server-rendered payload and re-apply the message immediately, so
   * the count is right without a page reload.
   */
  function observeCartRenders() {
    let scheduled = false;

    const observer = new MutationObserver((mutations) => {
      let dataNode = null;
      let sawCheckout = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          // Ignore the elements we inject ourselves, or this loops forever.
          if (node.classList.contains(NOTICE_CLASS)) return;

          if (node.matches('[data-fabric-sample-data]')) {
            dataNode = node;
          } else {
            const found = node.querySelector?.('[data-fabric-sample-data]');
            if (found) dataNode = found;
          }

          if (
            node.matches('button[name="checkout"]') ||
            node.querySelector?.('button[name="checkout"]')
          ) {
            sawCheckout = true;
          }
        });
      });

      if (!dataNode && !sawCheckout) return;
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;

        if (dataNode) {
          try {
            setState(JSON.parse(dataNode.textContent));
          } catch (error) {
            /* keep the previous state */
          }
        }

        renderUI();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  async function onCartChange(event) {
    // 1. Update the message immediately from the cart JSON the theme provides.
    const cart = event?.detail?.cart;
    if (cart) {
      applyCart(cart);
      renderUI();
    }

    // 2. Then reconcile against the server, which knows about collections and tags.
    if (busy) return;
    busy = true;

    try {
      await refresh();
      if (state.total > state.max) await trimToLimit();
      renderUI();
    } finally {
      busy = false;
    }
  }

  function initialize() {
    injectStyles();
    setState(readData());
    renderUI();
    interceptFetch();

    observeCartRenders();

    document.addEventListener('submit', onSubmitCapture, true);
    document.addEventListener('cart:change', onCartChange);
    document.addEventListener('cart-drawer:refreshed', (event) => {
      setState(readData(event.target) || readData());
      renderUI();
    });

    // Warm the ID cache when the browser is idle, so the first block is instant.
    const warm = () => ensureIds().catch(() => {});
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warm, { timeout: 4000 });
    } else {
      setTimeout(warm, 2000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  // Small public API, handy for debugging in the console.
  window.FabricSampleLimit = {
    get state() {
      return state;
    },
    get sampleVariants() {
      return [...sampleVariants];
    },
    refresh,
    renderUI,
  };
})();